__turbopack_context__.v({
  "bgImageContainer": "HeroSection-module-scss-module__NKxyBq__bgImageContainer",
  "bgImageContainerMobile": "HeroSection-module-scss-module__NKxyBq__bgImageContainerMobile",
  "blur": "HeroSection-module-scss-module__NKxyBq__blur",
  "container": "HeroSection-module-scss-module__NKxyBq__container",
  "content": "HeroSection-module-scss-module__NKxyBq__content",
  "description": "HeroSection-module-scss-module__NKxyBq__description",
  "link": "HeroSection-module-scss-module__NKxyBq__link",
  "title": "HeroSection-module-scss-module__NKxyBq__title",
});
